module.exports = __webpack_public_path__ + "assets/img/mark_color.7f36baa2.svg";